<template>
    <v-container fluid>
        <v-row class="px-6">
            <v-col
                class="mt-4 pb-2 px-0 text-h6"
                cols="9"
            >
                Center +Response
            </v-col>
            <v-col
                class="mt-4 pb-2 px-0 text-right"
                cols="3"
            >
                <v-btn
                    color="primary"
                    outlined
                    class="text-capitalize text-right"
                    @click="refresh"
                >
                    <v-icon left>
                        mdi-refresh
                    </v-icon>
                    Refresh
                </v-btn>
            </v-col>
            <v-col
                class="px-0"
                cols="12"
            >
                <v-tabs
                    v-model="tab"
                    background-color="#F5F7FA"
                >
                    <v-tab
                        key="1"
                        href="#queue-tab"
                    >
                        Queue <v-chip
                            class="ml-2 text-caption chip-count"
                            outlined
                        >
                            {{ queueFilteredData.length }}
                        </v-chip>
                    </v-tab>
                    <v-tab
                        key="2"
                        href="#recent-tab"
                    >
                        Recent <v-chip
                            class="ml-2 text-caption chip-count"
                            outlined
                        >
                            {{ recentFilteredData.length }}
                        </v-chip>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="1"
                        value="queue-tab"
                        :transition="false"
                    >
                        <v-menu
                            v-model="queueFilterMenu"
                            :close-on-content-click="false"
                            offset-y
                            :nudge-width="200"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    outlined
                                    v-bind="attrs"
                                    class="text-capitalize my-3"
                                    v-on="on"
                                >
                                    <v-icon left>
                                        mdi-filter-variant
                                    </v-icon>
                                    Filter
                                </v-btn>
                            </template>
                            <v-card>
                                <v-list>
                                    <v-row class="align-center justify-space-between">
                                        <v-col
                                            cols="8"
                                            class="px-6 font-weight-bold"
                                        >
                                            Filter
                                        </v-col>
                                        <v-col
                                            class="clear-email-filter"
                                            cols="3"
                                        >
                                            <a 
                                                :disabled="queueDateFilter.length == 0"
                                                :class="queueDateFilter.length > 0 ? 'enabled-btn' : 'disabled-btn'"
                                                @click="clearQueueFilter"
                                            >Clear</a>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            class="py-0 pr-8 pl-6"
                                            cols="12"
                                        >
                                            <v-menu
                                                ref="queueDateMenu"
                                                v-model="queueDateMenu"
                                                :close-on-content-click="false"
                                                :return-value.sync="queueDateFilter"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="queueDateText"
                                                        label="Date Range"
                                                        prepend-inner-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        outlined
                                                        dense
                                                        v-on="on"
                                                    />
                                                </template>
                                                <v-date-picker
                                                    v-model="queueDateFilter"
                                                    color="primary"
                                                    no-title
                                                    range
                                                    scrollable
                                                >
                                                    <v-spacer />
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="queueDateMenu = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.queueDateMenu.save(queueDateFilter)"
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mx-0 my-0">
                                        <v-col class="py-0">
                                            <v-btn
                                                class="ma-1 action-btn text-subtitle-2"
                                                style="float: right;"
                                                depressed
                                                color="primary"
                                                :disabled="queueDateFilter.length == 0"
                                                @click="applyQueueFilter"
                                            >
                                                Apply
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-list>
                            </v-card>
                        </v-menu>
                        <v-chip
                            v-if="queueFilterApplied && queueDateFilter.length>0"
                            color="#F5F7FA"
                            small
                            class="ma-2"
                            close
                            @click:close="clearQueueFilter"
                        >
                            {{ queueDateText }}
                        </v-chip>
                        <v-chip
                            v-if="queueFilterApplied && queueDateFilter.length>0"
                            color="white"
                            text-color="#1976D2"
                            @click="clearQueueFilter"
                        >
                            Clear
                        </v-chip>
                        <v-data-table
                            id="queue-table"
                            :loading="dataLoading"
                            loading-text="Fetching data..."
                            :headers="queueHeaders"
                            :items="queueFilteredData"
                            :footer-props="{
                                'items-per-page-options': perPageChoices
                            }"
                            :page.sync="queuePage"
                            fixed-header
                            :height="`calc(100vh - 400px)`"
                            hide-default-header
                            class="table-elevation"
                        >
                            <template v-slot:header="{ props: { headers } }">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="h in headers"
                                            :key="h.text"
                                            class="table-th"
                                            :style="{'text-align': h.align}"
                                        >
                                            <span>{{ h.text }}</span>
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                            <template v-slot:[`item.ticket`]="{item}">
                                <router-link
                                    :to="'/tickets/details?tid='+item.tid"
                                    style="text-decoration: none; color: #1976D2"
                                >
                                    {{ `${item.ticket} - ${item.revision}` }}
                                </router-link>
                            </template>
                            <template v-slot:[`item.queued`]="{item}">
                                {{ `${moment(item.queued).format('MM/DD/YYYY, hh:mm a')} (${moment(item.queued).fromNow()})` }}
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item
                        key="2"
                        value="recent-tab"
                        :transition="false"
                    >
                        <v-menu
                            v-model="recentFilterMenu"
                            :close-on-content-click="false"
                            offset-y
                            :nudge-width="200"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    outlined
                                    v-bind="attrs"
                                    class="text-capitalize my-3"
                                    v-on="on"
                                >
                                    <v-icon left>
                                        mdi-filter-variant
                                    </v-icon>
                                    Filter
                                </v-btn>
                            </template>
                            <v-card>
                                <v-list>
                                    <v-row class="align-center justify-space-between">
                                        <v-col
                                            cols="8"
                                            class="px-6 font-weight-bold"
                                        >
                                            Filter
                                        </v-col>
                                        <v-col
                                            class="clear-email-filter"
                                            cols="3"
                                        >
                                            <a 
                                                :disabled="recentDateFilter.length == 0"
                                                :class="recentDateFilter.length > 0 ? 'enabled-btn' : 'disabled-btn'"
                                                @click="clearRecentFilter"
                                            >Clear</a>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            class="py-0 pr-8 pl-6"
                                            cols="12"
                                        >
                                            <v-menu
                                                ref="recentDateMenu"
                                                v-model="recentDateMenu"
                                                :close-on-content-click="false"
                                                :return-value.sync="recentDateFilter"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="recentDateText"
                                                        label="Date Range"
                                                        prepend-inner-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        outlined
                                                        dense
                                                        v-on="on"
                                                    />
                                                </template>
                                                <v-date-picker
                                                    v-model="recentDateFilter"
                                                    color="primary"
                                                    no-title
                                                    range
                                                    scrollable
                                                >
                                                    <v-spacer />
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="recentDateMenu = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.recentDateMenu.save(recentDateFilter)"
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mx-0 my-0">
                                        <v-col class="py-0">
                                            <v-btn
                                                class="ma-1 action-btn text-subtitle-2"
                                                style="float: right;"
                                                depressed
                                                color="primary"
                                                :disabled="recentDateFilter.length == 0"
                                                @click="applyRecentFilter"
                                            >
                                                Apply
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-list>
                            </v-card>
                        </v-menu>
                        <v-chip
                            v-if="recentFilterApplied && recentDateFilter.length>0"
                            color="#F5F7FA"
                            small
                            class="ma-2"
                            close
                            @click:close="clearRecentFilter"
                        >
                            {{ recentDateText }}
                        </v-chip>
                        <v-chip
                            v-if="recentFilterApplied && recentDateFilter.length>0"
                            color="white"
                            text-color="#1976D2"
                            @click="clearRecentFilter"
                        >
                            Clear
                        </v-chip>
                        <v-data-table
                            id="recent-table"
                            :loading="dataLoading"
                            loading-text="Fetching data..."
                            :headers="recentHeaders"
                            :items="recentFilteredData"
                            :footer-props="{
                                'items-per-page-options': perPageChoices
                            }"
                            :page.sync="queuePage"
                            fixed-header
                            :height="`calc(100vh - 400px)`"
                            hide-default-header
                            class="table-elevation"
                        >
                            <template v-slot:header="{ props: { headers } }">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="h in headers"
                                            :key="h.text"
                                            class="table-th"
                                            :style="{'text-align': h.align}"
                                        >
                                            <span>{{ h.text }}</span>
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                            <template v-slot:[`item.ticket`]="{item}">
                                <router-link
                                    :to="'/tickets/details?tid='+item.tid"
                                    style="text-decoration: none; color: #1976D2"
                                >
                                    {{ `${item.ticket} - ${item.revision}` }}
                                </router-link>
                            </template>
                            <template v-slot:[`item.posresp_queued`]="{item}">
                                {{ `${moment(item.posresp_queued).format('MM/DD/YYYY, hh:mm a')} (${moment(item.posresp_queued).fromNow()})` }}
                            </template>
                            <template v-slot:[`item.posresp_date`]="{item}">
                                {{ `${moment(item.posresp_date).format('MM/DD/YYYY, hh:mm a')} (${moment(item.posresp_date).fromNow()})` }}
                            </template>
                            <template v-slot:[`item.posresp_sent`]="{item}">
                                {{ item.posresp_sent ? 'Yes' : 'No' }}
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';
export default {
    name: 'CenterResponse',
    data: () => ({
        tab: null,
        queueHeaders: [
            {text: 'Center', value: 'center', align: 'left'},
            {text: 'Ticket', value: 'ticket', align: 'left'},
            {text: 'Member Code', value: 'member_code', align: 'left'},
            {text: '+Response Code', value: 'response_code', align: 'left'},
            {text: '+Response By', value: 'response_by', align: 'left'},
            {text: 'Queued', value: 'queued', align: 'left'},
            {text: 'Response Comment', value: 'response_comment', align: 'left'}
        ],
        queueData: [],
        queuePage: 1,
        queueFilterMenu: false,
        recentHeaders: [
            {text: 'Center', value: 'center', align: 'left'},
            {text: 'Ticket', value: 'ticket', align: 'left'},
            {text: 'Terminal Code', value: 'terminal_code', align: 'left'},
            {text: 'Response', value: 'response_code', align: 'left'},
            {text: 'Queued', value: 'posresp_queued', align: 'left'},
            {text: '+Response Sent', value: 'posresp_sent', align: 'left'},
            {text: '+Response Code', value: 'posresp_code', align: 'left'},
            {text: 'Date', value: 'posresp_date', align: 'left'},
            {text: 'Audit', value: 'posresp_audit', align: 'left'},
        ],
        recentData: [],
        moment: moment,
        recentPage: 1,
        perPageChoices: [15, 25, 50, 100, 250, 500],
        recentFilterMenu: false,
        dataLoading: false,
        ticketsDefaultFilters: {
            'center': '*',
            'member_code': '*',
            'seq_date': '*',
            'stype': '*',
            'priority': '*',
            'type': '*',
            'category': '*',
            'TR_stage': '*',
            'fips': '*',
            'locator': '*',
            'due': '*',
            'ticket': '',
            'place': '',
            'workdate': '*',
            'updated': '*',
            'grid': '',
            'street': '',
            'address': '',
            'donefor': '',
            'location': '',
            'worktype': '',
            'comment': ''
        },
        queueDateMenu: false,
        queueDateFilter: [],
        queueFilteredData: [],
        recentDateMenu: false,
        recentDateFilter: [],
        recentFilteredData: [],
        queueFilterApplied: false,
        recentFilterApplied: false
    }),
    computed: {
        queueDateText() {
            return this.queueDateFilter.length > 0 ? this.queueDateFilter.map(dt => moment(dt).format('MM/DD/YYYY')).join(' ~ ') : '';
        },
        recentDateText() {
            return this.recentDateFilter.length > 0 ? this.recentDateFilter.map(dt => moment(dt).format('MM/DD/YYYY')).join(' ~ ') : '';
        }
    },
    async mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.dataLoading = true;
            let data = await webtmsBackend.getQueuePositiveResponse();

            this.queueData = [...data.queue];
            this.queueTotalTicketsCount = this.queueData.length;
            this.queueFilteredData = [...data.queue];
            this.resetQueuePagination();

            this.recentData = [...data.recent];
            this.recentTotalTicketsCount = this.recentData.length;
            this.recentFilteredData = [...data.recent];
            this.resetRecentPagination();
            
            this.dataLoading = false;
        },
        resetQueuePagination() {
            this.queuePage = 1;
        },
        resetRecentPagination() {
            this.recentPage = 1;
        },
        refresh() {
            this.getData();
        },
        clearQueueFilter() {
            this.queueDateFilter = [];
            this.$refs.queueDateMenu.save(this.queueDateFilter);
            this.queueFilteredData = [...this.queueData];
            this.queueTotalTicketsCount = this.queueData.length;
            this.resetQueuePagination();
            this.queueFilterMenu = false;
            this.queueFilterApplied = false;
        },
        applyQueueFilter() {
            let data = [...this.queueData];
            if (this.queueDateFilter.length === 2) {
                let sDate, eDate;
                if (moment(this.queueDateFilter[0]).isSameOrBefore(moment(this.queueDateFilter[1]))) {
                    sDate = moment(this.queueDateFilter[0]);
                    eDate = moment(this.queueDateFilter[1]).set({'hour':23, 'minutes': 59, 'seconds': 59});
                } else {
                    sDate = moment(this.queueDateFilter[1]);
                    eDate = moment(this.queueDateFilter[0]).set({'hour':23, 'minutes': 59, 'seconds': 59});
                }
                this.queueFilteredData = data.filter(item => {
                    let qDate = moment(item.queued).local();
                    return qDate.isSameOrAfter(sDate) && qDate.isSameOrBefore(eDate);
                });
            } else {
                let date = moment(this.queueDateFilter[0]);
                this.queueFilteredData = data.filter(item => {
                    let qDate = moment(item.queued).local().set({'hour':0, 'minutes': 0, 'seconds': 0});
                    return qDate.isSame(date);
                });
            }
            this.queueTotalTicketsCount = this.queueFilteredData.length;
            this.resetQueuePagination();
            this.queueFilterMenu = false;
            this.queueFilterApplied = true;
        },
        clearRecentFilter() {
            this.recentDateFilter = [];
            this.$refs.recentDateMenu.save(this.recentDateFilter);
            this.recentFilteredData = [...this.recentData];
            this.recentTotalTicketsCount = this.recentData.length;
            this.resetRecentPagination();
            this.recentFilterMenu = false;
            this.recentFilterApplied = false;
        },
        applyRecentFilter() {
            let data = [...this.recentData];
            if (this.recentDateFilter.length === 2) {
                let sDate, eDate;
                if (moment(this.recentDateFilter[0]).isSameOrBefore(moment(this.recentDateFilter[1]))) {
                    sDate = moment(this.recentDateFilter[0]);
                    eDate = moment(this.recentDateFilter[1]).set({'hour':23, 'minutes': 59, 'seconds': 59});
                } else {
                    sDate = moment(this.recentDateFilter[1]);
                    eDate = moment(this.recentDateFilter[0]).set({'hour':23, 'minutes': 59, 'seconds': 59});
                }
                this.recentFilteredData = data.filter(item => {
                    let qDate = moment(item.posresp_queued).local();
                    return qDate.isSameOrAfter(sDate) && qDate.isSameOrBefore(eDate);
                });
            } else {
                let date = moment(this.recentDateFilter[0]);
                this.recentFilteredData = data.filter(item => {
                    let qDate = moment(item.posresp_queued).local().set({'hour':0, 'minutes': 0, 'seconds': 0});
                    return qDate.isSame(date);
                });
            }
            this.recentTotalTicketsCount = this.recentFilteredData.length;
            this.resetRecentPagination();
            this.recentFilterMenu = false;
            this.recentFilterApplied = true;
        }
    }
};
</script>
<style scoped>
    .table-elevation {
        border: 1px solid rgb(0 0 0 / 20%);
        border-bottom: none;
        box-shadow: 0px 1px 1px -1px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
    }
    .table-th {
        background-color: #F5F7FA !important;
    }
    .ticket-count {
        color: rgba(0,0,0,.87);
        font-size: 12px;
        margin-left: 10px;
        border: 1px solid rgba(0,0,0,.54);
        padding: 5px !important;
    }
    .enabled-btn {
        color: #122448;
    }
    .disabled-btn {
        color: #D5D8DE;
    }
    .chip-count {
        border-radius: 20px !important;
        height: 18px !important;
        padding: 0px 4px !important;
    }
</style>